import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as section from '../../section'

/**
 * Presents a {@link ents.core.summit.Pulse.Highlight.Group}
 */
@ngCore.Component({
  imports: [section.Component],
  selector: 'atn-summit-pulse-highlights',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * All of the information displayed in this component
   *
   * @see {@link ents.core.summit.Pulse.Highlight.Group}
   */
  public readonly infoSg =
    ngCore.input.required<ents.core.summit.Pulse.Highlight.Group>({
      alias: 'info',
    })
}
